// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Cwiy","rightAdornment":"Header_rightAdornment__3eEij"};